/*
 * Syntax highlighting of the code blocks, with Prism from node_modules in
 * place of assets/js/support/prism.js (a 576 KB download build with all 297
 * languages) and prism-php.js. The common languages are part of the runtime;
 * a page with a code block in any other language loads prism-rest.js too.
 */
import './prism-manual.js';
import Prism from 'prismjs';
import './prism-common.js';
import REST_LANGUAGES from './prism-rest-names.js';

let rest = null;

function languagesUnder(root) {
    const names = new Set();
    root.querySelectorAll('[class*="language-"], [class*="lang-"]').forEach((el) => {
        const found = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i.exec(el.getAttribute('class') || '');
        if (found) names.add(found[1].toLowerCase());
    });
    return names;
}

function needsRest(root) {
    let needed = false;
    languagesUnder(root).forEach((name) => {
        if (!Prism.languages[name] && REST_LANGUAGES.indexOf(name) >= 0) needed = true;
    });
    return needed;
}

/** Highlights every code block under `root` (the whole page when left out). */
export function highlightUnder(root) {
    root = root || document;
    const run = () => {
        try {
            Prism.highlightAllUnder(root);
        } catch (e) {
            // A block Prism cannot read stays as plain text
        }
    };

    if (!needsRest(root)) {
        run();
        return Promise.resolve();
    }
    // What is ready is highlighted now; the rest when its languages arrive
    run();
    if (!rest) rest = import('./prism-rest.js').catch(() => null);
    return rest.then(run);
}

export default Prism;
